<template>
  <div class="p-4">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    queryColors () {
      return [
        {
          name: '--brand',
          value: this.brandColor,
        },
        {
          name: '--text',
          value: this.textColor,
        },
        {
          name: '--background',
          value: this.backgroundColor,
        },
        {
          name: '--light',
          value: this.lightColor,
        },
        {
          name: '--dark',
          value: this.darkColor,
        },
        {
          name: '--brand-text',
          value: this.brandTextColor,
        },
      ]
    },
    brandColor () {
      const fallbackLeveradeYellow = '#ffcd00'

      return this.$tinycolor(this.$route.query.brand_color || fallbackLeveradeYellow)
    },
    textColor () {
      const fallbackDeepGray = '#343434'

      return this.$tinycolor(this.$route.query.text_color || fallbackDeepGray)
    },
    backgroundColor () {
      const fallbackWhite = '#ffffff'

      return this.$tinycolor(this.$route.query.background_color || fallbackWhite)
    },
    lightColor () {
      if (this.textColor.getBrightness() > this.backgroundColor.getBrightness()) {
        return this.textColor.clone()
      } else {
        return this.backgroundColor.clone()
      }
    },
    darkColor () {
      if (this.backgroundColor.getBrightness() < this.textColor.getBrightness()) {
        return this.backgroundColor.clone()
      } else {
        return this.textColor.clone()
      }
    },
    brandTextColor () {
      return this.$tinycolor.mostReadable(
        this.$route.query.brand_color,
        [
          this.$route.query.text_color,
          this.$route.query.background_color,
        ],
        {
          includeFallbackColors: true,
        }
      )
    },
    styles () {
      const styles = [
        {
          name: '--font-size',
          value: this.$route.query.font_size || '16px',
        },
      ]

      this.queryColors.forEach((color) => {
        const white = '#ffffff'
        const black = '#000000'

        styles.push(
          {
            name: color.name + '-lightest',
            value: this.$tinycolor.mix(color.value, white, 37).toHexString(),
          },
          {
            name: color.name + '-lighter',
            value: this.$tinycolor.mix(color.value, white, 23).toHexString(),
          },
          {
            name: color.name + '-light',
            value: this.$tinycolor.mix(color.value, white, 11).toHexString(),
          },
          {
            name: color.name,
            value: color.value.clone().toHexString(),
          },
          {
            name: color.name + '-dark',
            value: this.$tinycolor.mix(color.value, black, 11).toHexString(),
          },
          {
            name: color.name + '-darker',
            value: this.$tinycolor.mix(color.value, black, 23).toHexString(),
          },
          {
            name: color.name + '-darkest',
            value: this.$tinycolor.mix(color.value, black, 37).toHexString(),
          }
        )
      })

      return styles
    },
  },

  watch: {
    '$route.query' () {
      const documentStyles = document.documentElement.style

      this.styles.forEach((styleVar) => {
        documentStyles.setProperty(styleVar.name, styleVar.value)
      })
    },
  },
}
</script>

<style lang="scss">
@import './sass/main';
</style>



// WEBPACK FOOTER //
// src/server/App.vue